import React from "react";

import { Container } from "react-bootstrap";

import DocumentComponent, {
  CANONICAL_ORIGIN,
} from "@/components/Document.component";
import { release20261015En } from "@/data/releases/2026-10-15-en.html";
import { release20261015Fr } from "@/data/releases/2026-10-15-fr.html";

import i18n from "../../i18n";

const Release20261015 = (): React.JSX.Element => {
  const { t, language } = i18n;

  const title = t("A Home Built from 200,000 Recycled Plastic Bottles");
  const description = t(
    "Québec cleantech company PakVille introduces a faster, more affordable way to build homes while reducing construction’s environmental footprint.",
  );
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: title,
    description,
    datePublished: "2026-10-15",
    inLanguage: language,
    author: { "@type": "Organization", name: "PakVille™" },
    publisher: {
      "@type": "Organization",
      name: "PakVille™",
      url: CANONICAL_ORIGIN,
      logo: {
        "@type": "ImageObject",
        url: `${CANONICAL_ORIGIN}/images/logo/pakville.png`,
      },
    },
  };

  return (
    <React.Fragment>
      <DocumentComponent
        description={description}
        jsonLd={jsonLd}
        title={title}
      />
      <Container as="article" className="pressRelease my-5">
        <div
          dangerouslySetInnerHTML={{
            __html: language === "fr" ? release20261015Fr : release20261015En,
          }}
        />
      </Container>
    </React.Fragment>
  );
};

export default Release20261015;
